import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { SectionHead } from '../../_shared/SectionHead'
import { StickerCard } from '../components/StickerCard'
import { STICKER_SERIES, type Sticker } from '../content'
import styles from './Stickers.module.css'

function StickerGrid({ stickers }: { stickers: Sticker[] }): React.ReactElement {
  return (
    <div className={styles.serie__grid}>
      {stickers.map((sticker) => (
        <StickerCard key={sticker.name} sticker={sticker} />
      ))}
    </div>
  )
}

export function Stickers(): React.ReactElement {
  return (
    <section className={styles.section} id="stickers">
      <Container>
        <SectionHead
          title="Stickers de campagne"
          lede="4 séries thématiques, 12 stickers individuels. Intégrez-les dans vos stories, publications et visuels de campagne. Vous pouvez modifier les textes en utilisant les SVG."
        />
        <div className={styles.series}>
          {STICKER_SERIES.map((serie) => {
            // Split a series into stickers that ship in several versions (a value/month picker) and
            // those with a single design. Sub-headings only appear when a series holds both kinds.
            const multiVersion = serie.stickers.filter((sticker) => sticker.variants !== undefined)
            const singleVersion = serie.stickers.filter((sticker) => sticker.variants === undefined)
            const split = multiVersion.length > 0 && singleVersion.length > 0

            return (
              <div key={serie.num}>
                <div className={styles.serie__head}>
                  <span
                    className={styles.serie__num}
                    style={{ color: serie.badge, background: serie.badgeBg }}
                    aria-hidden="true"
                  >
                    {serie.num}
                  </span>
                  <div>
                    <h3 className={styles.serie__title}>{serie.title}</h3>
                    <p className={styles.serie__desc}>{serie.description}</p>
                  </div>
                </div>

                {split ? (
                  <>
                    <div className={styles.subgroup}>
                      <p className={styles.subgroup__label}>Plusieurs versions</p>
                      <StickerGrid stickers={multiVersion} />
                    </div>
                    <div className={styles.subgroup}>
                      <p className={styles.subgroup__label}>Version unique</p>
                      <StickerGrid stickers={singleVersion} />
                    </div>
                  </>
                ) : (
                  <StickerGrid stickers={serie.stickers} />
                )}
              </div>
            )
          })}
        </div>

        <div className={styles.connect}>
          <span className={styles.connect__icon}>
            <plume.glyphs.stroke.Bubble />
          </span>
          <p className={styles.connect__text}>
            Besoin de feedbacks sur une illustration&nbsp;?{' '}
            <a href="https://connect.ulule.com" target="_blank" rel="noopener noreferrer">
              Rejoignez la communauté Ulule Connect
            </a>
          </p>
        </div>
      </Container>
    </section>
  )
}
